import { useQuery } from 'react-query'
import { getFriendGroupMembers } from '@services/requests/friendGroups'

export const useGetFriendGroupMembers = (groupId?: string) => {
  return useQuery(['friends', groupId, 'members'], () => {
    if (groupId === undefined) return []
    return getFriendGroupMembers(groupId)
  })
}
